module.exports = __webpack_public_path__ + "static/522319544-square.e227fe31.jpg";